/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/reducerLocationCountries.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for Location Countries
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Monday, May 13, 2019 - 05:55:18 PM (CST)
 *  
 *  Notes:
 *
 *  
 *  Revisions:
 *      05/13/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    LOCATIONCOUNTRY_LIST_CONTAINER_LOADED,
    LOCATIONCOUNTRY_LIST_CONTAINER_UNLOADED,
    LOCATIONCOUNTRY_LIST_TABLE_LOADED,
    LOCATIONCOUNTRY_LIST_TABLE_UNLOADED,

    LOCATIONCOUNTRY_SELECT_ROW,
    LOCATIONCOUNTRY_ADD,
    LOCATIONCOUNTRY_EDIT,
    LOCATIONCOUNTRY_DELETE,
    LOCATIONCOUNTRY_OPEN_WARNING,
    LOCATIONCOUNTRY_CLOSE_WARNING,
    LOCATIONCOUNTRY_DELETE_DISABLE,

    LOCATIONCOUNTRY_EDIT_CONTAINER_LOADED,
    LOCATIONCOUNTRY_EDIT_CONTAINER_UNLOADED,
    LOCATIONCOUNTRY_EDIT_FORM_LOADED,
    LOCATIONCOUNTRY_EDIT_FORM_UNLOADED,
    LOCATIONCOUNTRY_EDIT_DATA_LOAD,
    LOCATIONCOUNTRY_EDIT_CONTAINER_SUBMIT,
    LOCATIONCOUNTRY_EDIT_CONTAINER_CANCEL
} from '../constants/actionTypeLocationCountries';

const defaultState = {
    refreshList: false,
    danger: false,
    locationcountryid: 0,
    name: '',
    abbreviation: '',
    createdate: '',
    modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case LOCATIONCOUNTRY_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                locationcountries: action.payload[0] ? action.payload[0].records : null
            }
        case LOCATIONCOUNTRY_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case LOCATIONCOUNTRY_SELECT_ROW:
            return {
                ...state,
                locationcountryid: action.id
            }
        case LOCATIONCOUNTRY_ADD:
            return {
                ...state
            }
        case LOCATIONCOUNTRY_EDIT:
            return {
                ...state,
                locationcountryid: action.id
            }
        case LOCATIONCOUNTRY_DELETE:
            return {
                ...state,
                locationcountryid: null
            }
        case LOCATIONCOUNTRY_DELETE_DISABLE:
            return {
                ...state,
                disableDelete: action.disabled
            }
        case LOCATIONCOUNTRY_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case LOCATIONCOUNTRY_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case LOCATIONCOUNTRY_EDIT_CONTAINER_LOADED:
        case LOCATIONCOUNTRY_EDIT_DATA_LOAD:
            return {
                ...state,
                locationcountryid: action.payload[0] ? action.payload[0].locationcountryid : 0,
                name: action.payload[0] ? action.payload[0].name : '',
                abbreviation: action.payload[0] ? action.payload[0].abbreviation : '',
                createdate: action.payload[0] ? action.payload[0].createdate : '',
                modifydate: action.payload[0] ? action.payload[0].modifydate : ''
            }
        case LOCATIONCOUNTRY_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case LOCATIONCOUNTRY_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case LOCATIONCOUNTRY_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case LOCATIONCOUNTRY_LIST_CONTAINER_UNLOADED:
        case LOCATIONCOUNTRY_LIST_TABLE_UNLOADED:
        case LOCATIONCOUNTRY_EDIT_CONTAINER_UNLOADED:
        case LOCATIONCOUNTRY_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/reducerLocationCountries.js